<div class="container-date-input">
  <label class="label-date">
    {{ label }}
    <span *ngIf="required" class="required-asterisk">*</span>
  </label>

  <mat-form-field
    *ngIf="!range"
    appearance="outline"
    [ngClass]="error ? 'generic-datepicker error' : 'generic-datepicker'"
  >
    <input
      class="input-date"
      matInput
      [matDatepicker]="singlePicker"
      [placeholder]="placeholder"
      [min]="minDate"
      [max]="maxDate"
      [matDatepickerFilter]="datepickerFilter"
      [disabled]="disabled"
      [value]="value"
      (dateChange)="handleDateChange($event)"
      (dateInput)="dateInput.emit($event)"
    />
    <mat-datepicker-toggle matSuffix [for]="singlePicker">
      <ds-icon
        matDatepickerToggleIcon
        icon="calendar-line"
        class="calendar-icon"
        [type]="error ? 'danger' : 'info'"
        [disabled]="disabled"
      ></ds-icon>
    </mat-datepicker-toggle>
    <mat-datepicker
      [panelClass]="forceClass"
      #singlePicker
      [startView]="startView"
      [touchUi]="touchUi"
      [startAt]="startAt"
      (monthSelected)="handleMonthSelected($event, singlePicker)"
      (opened)="openedDatepicker.emit()"
      (closed)="closedDatepicker.emit()"
      (yearSelected)="yearSelected.emit($event)"
      (selectedChanged)="selectedChanged.emit($event)"
    ></mat-datepicker>
    <mat-hint *ngIf="hintText">{{ hintText }}</mat-hint>
  </mat-form-field>

  <mat-form-field
    *ngIf="range"
    appearance="outline"
    [ngClass]="error ? 'generic-datepicker error' : 'generic-datepicker'"
  >
    <mat-date-range-input
      [rangePicker]="rangePicker"
      [formGroup]="formGroup"
      [disabled]="disabled"
      [min]="minDate"
      [max]="maxDate"
      [dateFilter]="datepickerFilter"
    >
      <input
        matStartDate
        formControlName="start"
        [placeholder]="placeholderStartDate"
        (dateChange)="handleStartDateChange($event)"
        (dateInput)="handleStartDateInput($event)"
      />
      <input
        matEndDate
        formControlName="end"
        [placeholder]="placeholderEndDate"
        (dateChange)="handleEndDateChange($event)"
        (dateInput)="handleEndDateInput($event)"
      />
    </mat-date-range-input>
    <mat-datepicker-toggle matSuffix [for]="rangePicker">
      <ds-icon
        matDatepickerToggleIcon
        icon="calendar-line"
        class="calendar-icon"
        [type]="error ? 'danger' : 'info'"
        [disabled]="disabled"
      ></ds-icon>
    </mat-datepicker-toggle>
    <mat-date-range-picker
      #rangePicker
      [startView]="startView"
      [startAt]="startAt"
      [touchUi]="touchUi"
      [panelClass]="forceClass"
      (opened)="openedDatepicker.emit()"
      (closed)="closedDatepicker.emit()"
    ></mat-date-range-picker>
    <mat-hint *ngIf="hintText">{{ hintText }}</mat-hint>
  </mat-form-field>
</div>
